// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"hotspots_iframeContainer__20tbd","iframe":"hotspots_iframe__DyfKu"};